import React from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import logo from "../../../Pages/Images/SMJ_Logo.png";
import instalogo from "../../../Pages/Images/insta_logo.png";
import diamondIcon from "../../../Pages/Images/diamond.png";
import sparkaleIcon from "../../../Pages/Images/Sparkle.png";
import giftIcon from "../../../Pages/Images/Gift.png";
import ringIcon from "../../../Pages/Images/Ring.jpeg";
import moneyIcon from "../../../Pages/Images/Money.jpg";
import voucherIcon from "../../../Pages/Images/Voucher.png";
import qrScanner from "../../../Pages/Images/QR1.png";

Font.register({
    family: "Helvetica",
});

Font.register({
    family: "Helvetica-Bold",
    src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf",
});

// Helper function to format date/time
const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};

const formatTime = (date) => {
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? String(hours).padStart(2, "0") : "12";
    return `${hours}:${minutes}:${seconds} ${period}`;
};

const styles = StyleSheet.create({
    page: { padding: 8, fontSize: 8, fontFamily: "Helvetica" },
    topRow: { flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: 3 },
    smallBold: { fontSize: 8, fontFamily: "Helvetica-Bold" },
    logo: { width: 40, height: 40, marginHorizontal: 4 },
    title: { fontSize: 14, fontFamily: "Helvetica-Bold", textAlign: "center" },
    tagline: { fontSize: 9, fontStyle: "italic", textAlign: "center", marginTop: 4 },
    address: { fontSize: 8, marginTop: 5, textAlign: "center" },
    sup: { fontSize: 5, textBaseline: "alphabetic" },
    sectionRow: { flexDirection: "row", justifyContent: "space-between", marginTop: 8, paddingHorizontal: 2 },
    sectionLeft: { width: "60%" },
    sectionRight: { width: "40%", textAlign: "right" },
    label: { fontSize: 9, fontFamily: "Helvetica-Bold" },
    value: { fontSize: 8, marginBottom: 1 },
    table: { display: "table", width: "100%", borderWidth: 0.5, borderColor: "#000", marginTop: 6 },
    tableRow: { flexDirection: "row" },
    tableHeaderText: { fontSize: 8, color: "#fff", fontFamily: "Helvetica-Bold", textAlign: "center" },
    tableCell: { fontSize: 8, textAlign: "center" },
    colSNo: { width: "10%", borderWidth: 0.5, borderColor: "#000", padding: 2, justifyContent: "center" },
    colMetal: { width: "12%", borderWidth: 0.5, borderColor: "#000", padding: 2, justifyContent: "center" },
    colParticulars: { width: "40%", borderWidth: 0.5, borderColor: "#000", padding: 2, justifyContent: "center" },
    colNtWt: { width: "25%", borderWidth: 0.5, borderColor: "#000", padding: 2, justifyContent: "center" },
    colAmount: { width: "25%", borderWidth: 0.5, borderColor: "#000", padding: 2, justifyContent: "center" },
    summaryRow: { flexDirection: "row", marginTop: 6 },
    summaryRight: { flex: 1, borderWidth: 0.5, borderColor: "#000" },
    summaryHeader: { backgroundColor: "#000", flexDirection: "row" },
    summaryHeaderText: { flex: 1, color: "#fff", fontSize: 7, fontFamily: "Helvetica-Bold", textAlign: "center", padding: 2 },
    summaryRowItem: { flexDirection: "row", borderTopWidth: 0.5, borderColor: "#000" },
    summaryCell: { flex: 1, fontSize: 7, textAlign: "center", padding: 2 },
    noteSection: { marginTop: 6, marginBottom: 8 },
    noteHeading: { fontSize: 9, fontFamily: "Helvetica-Bold", marginBottom: 3 },
    noteText: { fontSize: 8, marginBottom: 2 },
    footer: { marginTop: 12, alignItems: "center" },
    thankYou: { fontSize: 11, fontFamily: "Helvetica-Bold", marginBottom: 4 },
    copyright: { fontSize: 8, marginTop: 6 },
});

const promoStyles = StyleSheet.create({
    page: { padding: 8, fontSize: 8, fontFamily: "Helvetica" },
    topRow: { flexDirection: "row", justifyContent: "space-between", alignItems: "center" },
    smallBold: { fontSize: 8, fontFamily: "Helvetica-Bold" },
    logo: { width: 30, height: 30, marginHorizontal: 4 },
    title: { fontSize: 14, fontFamily: "Helvetica-Bold", textAlign: "center" },
    tagline: { fontSize: 9, fontStyle: "italic", textAlign: "center", marginTop: 4 },
    address: { fontSize: 8, marginTop: 5, textAlign: "center" },
    sup: { fontSize: 5, textBaseline: "alphabetic" },
    promoContainer: { marginTop: 8 },
    mainTitle: { fontSize: 12, fontFamily: "Helvetica-Bold", textAlign: "center", marginRight: 6 },
    subtitle: { fontSize: 9, textAlign: "center", marginBottom: 10, lineHeight: 1.3 },
    investmentSection: { marginBottom: 10 },
    investmentTitle: { fontSize: 12, fontFamily: "Helvetica-Bold", marginBottom: 4 },
    investmentSubtitle: { fontSize: 9, fontStyle: 'italic', marginBottom: 6 },
    featureItem: { flexDirection: 'row', alignItems: 'flex-start', marginBottom: 3 },
    featureText: { fontSize: 9, lineHeight: 1.2, flex: 1 },
    footer: { marginTop: 8, alignItems: "center" },
    thankYou: { fontSize: 11, fontFamily: "Helvetica-Bold", marginBottom: 4 },
    copyright: { fontSize: 8, marginTop: 6 },
    separator: { borderTopWidth: 0.5, borderTopColor: '#000', marginVertical: 6 },
    instaRow: { flexDirection: "row", alignItems: "center", justifyContent: "center", marginTop: 4 },
    instaLogo: { width: 10, height: 10, marginRight: 3 },
    instaText: { fontSize: 8 },
});

const PDFContent = ({ repairDetails, sellerName }) => {
    console.log("Repair details=", repairDetails)
    const currentDate = new Date();
    const formattedDate = formatDate(currentDate);
    const currentTime = formatTime(currentDate);
    
    // Calculate totals from all items
    const totalTaxableAmt = (repairDetails.items ? repairDetails.items.reduce((sum, item) => sum + parseFloat(item.total_price || 0), 0) : 0);
    
    const totalTaxAmt = (repairDetails.items ? repairDetails.items.reduce((sum, item) => sum + parseFloat(item.tax_amt || 0), 0) : 0);
    console.log("totalTaxAmt=",totalTaxAmt)
    const totalNetBillAmt = totalTaxableAmt + totalTaxAmt;

    const taxPercent = 5; // 5% GST
    const cgst = totalTaxAmt / 2; 
    const sgst = totalTaxAmt / 2;

    return (
        <Document>
            {/* ================== PAGE 1 ================== */}
            <Page size={[300, 500]} style={styles.page}>
                {/* Top Row: GSTIN | Logo | Contact */}
                <View style={styles.topRow}>
                    <Text style={styles.smallBold}>GSTIN: 29ADOPG5916E1ZE</Text>
                    <Image src={logo} style={styles.logo} />
                    <View>
                        <Text style={styles.smallBold}>Contact: 916 916 9680</Text>
                        <Text style={[styles.smallBold, { marginLeft: 33 }]}>080 26719107</Text>
                    </View>
                </View>

                {/* Title + tagline + address */}
                <Text style={styles.title}>Sri Mahaganapathi Jewellers</Text>
                <Text style={[styles.tagline, { marginLeft: 50 }]}>
                    Our Craft For Your Precious Stories
                </Text>
                <Text style={styles.address}>
                    No 606, 14<Text style={styles.sup}>th</Text> Main Road, Siddanna Layout,
                    BSK 2<Text style={styles.sup}>nd</Text> Stage
                </Text>

                {/* Estimation Details */}
                <View style={styles.sectionRow}>
                    <View style={styles.sectionLeft}>
                        <Text style={styles.label}>Repair Details:</Text>
                        <Text style={styles.value}>Repair No: {repairDetails.order_number || "N/A"}</Text>
                        <Text style={styles.value}>Seller: {sellerName}</Text>
                        <Text style={styles.value}>Customer: {repairDetails.account_name || "N/A"}</Text>
                        <Text style={styles.value}>Mobile: {repairDetails.mobile || "N/A"}</Text>
                    </View>
                    <View style={styles.sectionRight}>
                        <Text style={styles.value}>Invoice No: {repairDetails.invoice_number || "N/A"}</Text>
                        <Text style={styles.value}>Date: {formattedDate}</Text>
                        <Text style={styles.value}>Time: {currentTime}</Text>
                    </View>
                </View>

                {/* Items Table */}
                <View style={styles.table}>
                    {/* Header */}
                    <View style={styles.tableRow}>
                        <View style={[styles.colSNo, { backgroundColor: "#000" }]}>
                            <Text style={styles.tableHeaderText}>S.No</Text>
                        </View>
                       
                        <View style={[styles.colParticulars, { backgroundColor: "#000" }]}>
                            <Text style={styles.tableHeaderText}>Particulars</Text>
                        </View>
                        <View style={[styles.colNtWt, { backgroundColor: "#000" }]}>
                            <Text style={styles.tableHeaderText}>Gr. Wt</Text>
                        </View>
                        <View style={[styles.colAmount, { backgroundColor: "#000" }]}>
                            <Text style={styles.tableHeaderText}>Amount</Text>
                        </View>
                    </View>

                    {/* Dynamic Rows for Multiple Items */}
                    {repairDetails.items && repairDetails.items.map((item, index) => (
                        <View style={styles.tableRow} key={index}>
                            <View style={styles.colSNo}>
                                <Text style={styles.tableCell}>{index + 1}</Text>
                            </View>

                            <View style={styles.colParticulars}>
                                <Text style={styles.tableCell}>
                                    {item.category}
                                </Text>
                            </View>
                            <View style={styles.colNtWt}>
                                <Text style={styles.tableCell}>{item.gross_weight}g</Text>
                            </View>
                            <View style={styles.colAmount}>
                                <Text style={styles.tableCell}>{parseFloat(item.total_price || 0).toFixed(2)}</Text>
                            </View>
                        </View>
                    ))}
                </View>

                {/* Summary Section */}
                <View style={styles.summaryRow}>
                    <View style={styles.summaryRight}>
                        <View style={styles.summaryHeader}>
                            <Text style={styles.summaryHeaderText}>GST Calculation</Text>
                            <Text style={styles.summaryHeaderText}>Amount</Text>
                        </View>
                        <View style={styles.summaryRowItem}>
                            <Text style={styles.summaryCell}>Taxable Value</Text>
                            <Text style={styles.summaryCell}>{totalTaxableAmt.toFixed(2)}</Text>
                        </View>
                        <View style={styles.summaryRowItem}>
                            <Text style={styles.summaryCell}>CGST @{(taxPercent / 2).toFixed(2)}%</Text>
                            <Text style={styles.summaryCell}>{cgst.toFixed(2)}</Text>
                        </View>
                        <View style={styles.summaryRowItem}>
                            <Text style={styles.summaryCell}>SGST @{(taxPercent / 2).toFixed(2)}%</Text>
                            <Text style={styles.summaryCell}>{sgst.toFixed(2)}</Text>
                        </View>
                        <View style={styles.summaryRowItem}>
                            <Text style={[styles.summaryCell, { fontFamily: "Helvetica-Bold" }]}>Final Amount</Text>
                            <Text style={[styles.summaryCell, { fontFamily: "Helvetica-Bold" }]}>{totalNetBillAmt.toFixed(2)}</Text>
                        </View>
                    </View>
                </View>

                {/* Note Section */}
                <View style={styles.noteSection}>
                    <Text style={styles.noteHeading}>Note:</Text>
                    <Text style={styles.noteText}>
                        1. Ensure that your article is properly repaired at the time of delivery.
                    </Text>
                    <Text style={styles.noteText}>
                        2. In the event that any damage is observed after the delivery of the article, repair services will be provided at an additional cost.
                    </Text>
                </View>

                {/* Footer */}
                <View style={styles.footer}>
                    <Text style={styles.thankYou}>Thank You | Visit Again</Text>
                    <View style={{ flexDirection: "row", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                        <View style={{ flexDirection: "row", alignItems: "center" }}>
                            <Image
                                src={instalogo}
                                style={{ width: 12, height: 12, marginRight: 1, marginTop: 5 }}
                            />
                            <Text style={styles.copyright}>jewellers_srimahaganapathi</Text>
                        </View>
                        <Text style={styles.copyright}>SMJ Authorized Sign</Text>
                    </View>
                </View>
            </Page>

            {/* ================== PAGE 2 (Promo Page) ================== */}
         
        </Document>
    );
};

export default PDFContent;